let hideScimProvisioningErrors = false;

/** @type {(value: boolean) => void} */
export const setHideProvisioningErrors = value => {
	if (typeof value !== "boolean") {
		throw new Error("Invalid value for hideScimProvisioningErrors");
	}
	hideScimProvisioningErrors = value;
};

/** @type {() => boolean} */
export const getHideProvisioningErrors = () => {
	return hideScimProvisioningErrors;
};
